import { LanguageOption } from "./ScorecardLanguageSelect.decl";

// en,es,fr,it,de,nl
export const SCORE_CARD_LANGUAGES: LanguageOption[] = [
  {
    languageCode: "en",
    name: "English",
  },
  {
    languageCode: "es",
    name: "Español",
  },
  {
    languageCode: "fr",
    name: "Français",
  },
  {
    languageCode: "it",
    name: "Italiano",
  },
  {
    languageCode: "de",
    name: "Deutsch",
  },
  {
    languageCode: "nl",
    name: "Nederlandse",
  },
];
